module.exports = __webpack_public_path__ + "static/paypal-6cc092ea9a70bd088cc3a88b64b5eb2b.png";